export const Loaders = {
  User: {
    UserPostsLoadmore: 'user-posts-loadmore',
    UserRelatedUserLoadmore: 'user-related-user-loadmore',
  },
  Article: {
    ArticleRelatedLoadmore: 'article-related-loadmore',
    ArticleCommentsLoadmore: 'article-comments-loadmore',
    ArticleCommentRepliesLoadmore: 'article-comment-replies-loadmore',
  },
  POI: {
    POIPostsLoadmore: 'poi-posts-loadmore',
  },
  Hashtag: {
    HashtagPostsLoadmore: 'hashtag-posts-loadmore',
  },
};
